export default __webpack_public_path__ + "static/media/warranty_solutions.94bd04d4.png";